import { Col, Modal, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { ReactComponent as DeleteIcon } from '../../../../../../assets/icons/delete-icon.svg';
import {
  deleteRoutingGuideCarrierProgress,
  deleteRoutingGuideCollaboratorProgress,
} from '../../../../../../redux/RoutingGuide/RoutingGuideAction';
import SvgConverter from '../../../../../components/Common/SvgConverter';

const HalDeleteUserModal = ({
  handleCloseDeleteModal,
  carrier,
  isModalOpen,
  selectedRouting,
  isForCollaborator,
  collaborator,
  customSubmit,
}) => {
  const dispatch = useDispatch();
  const handleOk = () => {
    if (customSubmit) {
      !isForCollaborator ? customSubmit(carrier?.carrierId) : customSubmit(collaborator?.userId);
    } else {
      !isForCollaborator
        ? dispatch(
            deleteRoutingGuideCarrierProgress({
              routingGuideId: selectedRouting,
              carrierId: carrier?.carrierId,
            }),
          )
        : dispatch(
            deleteRoutingGuideCollaboratorProgress({
              routingGuideId: selectedRouting,
              collaboratorId: collaborator?.userId,
            }),
          );
    }
  };

  return (
    <Modal
      data-testid="deleteModal"
      open={isModalOpen}
      onOk={handleOk}
      okText="Submit"
      okType="danger"
      onCancel={handleCloseDeleteModal}
      centered
      className="hal-delete-user-modal"
    >
      <Row align="middle" gutter={16}>
        <Col data-testid="deleteIcon">
          <SvgConverter Icon={DeleteIcon} color="danger" width={17} height={17} />
        </Col>
        <Col data-testid="deleteCaption">
          <div>
            <p className="fw-600 f-28">{isForCollaborator ? 'Delete User' : 'Delete provider'}</p>
            <p>
              Are you sure that you want delete{' '}
              {isForCollaborator
                ? `${collaborator?.name || 'this'} user?`
                : `${carrier?.transportationProvider} provider?`}
            </p>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default HalDeleteUserModal;
